export { AtnDsPageHeaderComponent as Component } from './page-header.component'
export * as child from './components'
export * as models from './models'
